import React from 'react';
import TableDirectory from '../Components/database/directorydatabase/tabledatabase.directory.component';
import { makeStyles} from '@material-ui/core/styles';
import { Box, InputBase, Grid, Paper, Button } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        margin: '10px auto 0 auto',
        marginLeft :'60px',
        marginRight: '60px'

    }
})) 

 const DatabaseNew = () => {
    const classes = useStyles();
    return (
        <div className={classes.root}>
                  <TableDirectory /> 
       </div>

    )
}
export default DatabaseNew